import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { callEdgeFunction } from '../../lib/supabase'
import { ErrorAlert } from '../../components/ui'

export default function CreateClientPair() {
  const { t } = useTranslation('admin')
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    male_name: '',
    male_email: '',
    female_name: '',
    female_email: '',
  })
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const updateField = (field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    if (formData.male_email === formData.female_email) {
      setError(t('createClientPair.sameEmailError'))
      return
    }

    setLoading(true)
    try {
      const result = await callEdgeFunction('create-client-pair', formData)
      navigate(`/facilitator/pair/${result.pair.id}`)
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const inputClass = "w-full px-4 py-3 border-2 border-gray-200 rounded-lg text-base transition-all focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-100"

  return (
    <div className="max-w-lg animate-fadeIn">
      <div className="mb-6">
        <Link to="/facilitator" className="text-gray-500 hover:text-gray-700 font-semibold transition-colors">
          {t('createClientPair.backToDashboard')}
        </Link>
      </div>

      <div className="bg-white rounded-xl p-8 shadow-sm">
        <h2 className="font-display text-2xl font-medium text-gray-800 mb-2">{t('createClientPair.title')}</h2>
        <p className="text-gray-500 text-sm mb-6">
          {t('createClientPair.description')}
        </p>

        <ErrorAlert message={error} onDismiss={() => setError(null)} />

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-blue-50 rounded-lg p-5">
            <h3 className="font-semibold text-blue-800 mb-4">{t('createClientPair.maleClient')}</h3>
            <div className="space-y-4">
              <div>
                <label className="block font-semibold text-gray-800 mb-2">{t('createClientPair.fullNameLabel')}</label>
                <input
                  type="text"
                  className={inputClass}
                  value={formData.male_name}
                  onChange={updateField('male_name')}
                  placeholder={t('createClientPair.fullNamePlaceholder')}
                  required
                />
              </div>
              <div>
                <label className="block font-semibold text-gray-800 mb-2">{t('createClientPair.emailLabel')}</label>
                <input
                  type="email"
                  className={inputClass}
                  value={formData.male_email}
                  onChange={updateField('male_email')}
                  placeholder={t('createClientPair.emailPlaceholder')}
                  required
                />
              </div>
            </div>
          </div>

          <div className="bg-pink-50 rounded-lg p-5">
            <h3 className="font-semibold text-pink-800 mb-4">{t('createClientPair.femaleClient')}</h3>
            <div className="space-y-4">
              <div>
                <label className="block font-semibold text-gray-800 mb-2">{t('createClientPair.fullNameLabel')}</label>
                <input
                  type="text"
                  className={inputClass}
                  value={formData.female_name}
                  onChange={updateField('female_name')}
                  placeholder={t('createClientPair.fullNamePlaceholder')}
                  required
                />
              </div>
              <div>
                <label className="block font-semibold text-gray-800 mb-2">{t('createClientPair.emailLabel')}</label>
                <input
                  type="email"
                  className={inputClass}
                  value={formData.female_email}
                  onChange={updateField('female_email')}
                  placeholder={t('createClientPair.emailPlaceholder')}
                  required
                />
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white rounded-xl font-semibold transition-all hover:shadow-lg hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {loading ? t('createClientPair.creating') : t('createClientPair.createButton')}
          </button>
        </form>
      </div>
    </div>
  )
}
